import {ticketsystem2ApiType} from "./ticketsystem2Api.interface";
import {requests} from "../../../../@WUM/core/RestFullApi/api";
import {
    pluginApiResponse,
    RecordsAllPaginated, TicketActivityRecord,
    ticketApiResponse,
    ticketApiType,
    WorkLogEntry
} from "./ticket.interface";
import {memberApiType} from "../../../ticketsystem/API/request/memberApi.interface";
import {dashboardApiInterface} from "./dashboard.interface";
import {PrioApiType} from "../../../ticketsystem/API/request/Prio.interface";
import {LabelsApiType} from "../../../ticketsystem/API/request/Labels.interface";

export const ticketsystem2 = {
    getPosts: (archiv:any): Promise<ticketApiType[]> =>
        requests.get(`${archiv}/yoptimize/ticket/`),
    getAllPlugin: (): Promise<pluginApiResponse[]> =>
        requests.get(`yoptimize/ticket/plugin/all/`),
    getSortedTickets: (archiv:string, searchString: string, limit: number, pageNumber: number, direction: "ASC" | "DESC", column: string): Promise<ticketApiResponse> =>
        requests.get(`${archiv}/yoptimize/ticket/?${searchString}&limit=${limit}&page=${pageNumber}&direction=${direction}&column=${column}`), //
    getPostsSingle: (id:any): Promise<ticketApiType[]> =>
        requests.get(`yoptimize/ticket/${id}/`),
    getPostsTrigger: (): Promise<LabelsApiType[]> =>
        requests.get(`yoptimize/fetch/system/trigger/TicketSystem/`),
    getPostsSingleComment: (id:any): Promise<ticketApiType[]> =>
        requests.get(`yoptimize/Comment/${id}/`),
    createPost: (post: ticketsystem2ApiType): Promise<ticketsystem2ApiType> =>
        requests.post('save/activity_recording/yoptimize/', post),
    updatePost: (post: any, id: number): Promise<ticketsystem2ApiType> =>
        requests.put(`User/update/${id}/`, post),
    deletePost: (id: any): Promise<void> =>
        requests.delete(`User/delete/${id}/`),
    getPostsTaskDashbaord: (id:any): Promise<dashboardApiInterface> =>
        requests.get(`yoptimize/reports/ticket/`),
    getPostsTemplate: (): Promise<PrioApiType[]> =>
        requests.get(`template/ticket/yoptimize/`),
    getPostsEmailSettings: (): Promise<PrioApiType[]> =>
        requests.get(`yoptimize/tickets/settings/`),
    getPostsNotifications: (): Promise<PrioApiType[]> =>
        requests.get(`notifications/ticket/yoptimize/`),
    createDepartment: (post: ticketsystem2ApiType,eid:any,did:any): Promise<ticketsystem2ApiType> =>
        requests.post(`yoptimize/email/department/save/${eid}/${did}/`, post),
    getTicketRecords: (id: string): Promise<WorkLogEntry[]> =>
        requests.get(`ticket/yoptimize/record/${id}/`),
    getAllTicketRecordsYear: (year: string, limit: number, pageNumber: number, direction: "ASC" | "DESC", column: string): Promise<RecordsAllPaginated> =>
        requests.get(`ticket/yoptimize/record/bill/year/${year}/?&limit=${limit}&page=${pageNumber}&direction=${direction}&column=${column}`),
    getAllTicketRecordsDay: (day: string, limit: number, pageNumber: number, direction: "ASC" | "DESC", column: string): Promise<RecordsAllPaginated> =>
        requests.get(`ticket/yoptimize/record/bill/from/${day}/?&limit=${limit}&page=${pageNumber}&direction=${direction}&column=${column}`),
    getAllTicketRecordsBetween: (from: string, to: string, limit: number, pageNumber: number, direction: "ASC" | "DESC", column: string): Promise<RecordsAllPaginated> =>
        requests.get(`ticket/yoptimize/record/bill/until/${from}/${to}/?&limit=${limit}&page=${pageNumber}&direction=${direction}&column=${column}`),
    getNotesGeneral: (id: string): Promise<WorkLogEntry[]> =>
        requests.get(`ticket/yoptimize/note/general/${id}/`),
    getNotesActivityReport: (ticketId: string, recordId: string): Promise<TicketActivityRecord[]> =>
        requests.get(`ticket/yoptimize/note/activity/report/${ticketId}/${recordId}/`),
    getNotesRecordTime: (ticketId: string, recordId: string): Promise<TicketActivityRecord[]> =>
        requests.get(`ticket/yoptimize/note/recordtime/${ticketId}/${recordId}/`),



}
